import { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';
import { WithUncontrolledPopover } from '@ardoq/popovers';

const InlineAnchor = styled.span`
  display: inline-flex;
`;

/**
 * Wraps a trigger with a hover popover that renders arbitrary (interactive)
 * React content via popover2025's `WithUncontrolledPopover`. Hovering the
 * popover keeps it open so links/buttons inside stay clickable. When
 * `popoverContent` is absent the child renders as-is (no wrapper). The
 * inline-flex anchor catches hover even when the trigger has
 * `pointer-events: none` (e.g. a disabled button), so the popover still opens.
 */
export const SettingsBarContentPopover = ({
  popoverContent,
  children,
}: {
  popoverContent?: ReactNode;
  children: ReactElement;
}): ReactElement =>
  popoverContent ? (
    <WithUncontrolledPopover content={<>{popoverContent}</>}>
      <InlineAnchor>{children}</InlineAnchor>
    </WithUncontrolledPopover>
  ) : (
    children
  );
